export const FEEDBACK_TOOLTIP_TIMEOUT = 300;

export const SUBMISSION_TYPE = {
	bid: 'bid',
	bin: 'buy it now offer',
	offer: 'offer',
} as const;

export const TOAST_MESSAGE = {
	bid: 'bidToast',
	bin: 'buyToast',
	offer: 'offerToast',
} as const;
